import React from 'react'
import { FView } from 'f-web-app/components'

export default function NavbarView({ className }) {
  return <FView w="100%" row justifyBetween alignCenter h="5rem" maxWidth={'42rem'} className={className}></FView>
}
